import { authHeader, httpHelper} from '../helpers';
import { get } from 'axios';

export const utilHelper = {
    pad,
    getStoredCodes,
    getCodesByParent,
    getCodesByGroup,
    getCodeName,
    getStringDate,
    getStringTime,
    dateFromMysqlDateTime,
    getNowDate,
    lastDays,
    isNumber,
    dhm,
};

function pad(n, z) {
    // Pad to 2 or 3 digits, default is 2
    z = z || 2;
    return ('00' + n).slice(-z);
}

function getStoredCodes() {
    return localStorage.getItem('codes') ? JSON.parse(localStorage.getItem('codes')) : [];
}

function getCodesByParent(parentCode) {
    const codes = getStoredCodes();
    return codes.filter((c) => {
        return c.parentCode === parentCode && c.code !== parentCode;
    });
}

function getCodesByGroup(groupCode, parentCode) {
    const codes = getStoredCodes();
    return codes.filter((c) => {
        let result = false;
        if(c.groupCode === groupCode){
            if(parentCode)
                result = parentCode === c.parentCode && parentCode !== c.code ? true : false;
            else
                result = c.code === c.parentCode ? true : false;
        }

        return result
    });
}

function getCodeName(targetCode) {
    const codes = getStoredCodes();
    for(let i=0; i < codes.length; i++) {
        if(codes[i].code === targetCode)
            return codes[i].name;
    }
}

function getStringDate(date, fillZero, splitter){
    fillZero = fillZero || true;
    splitter = splitter || '-';
    
    let year  = date.getFullYear();
    let month = date.getMonth() + 1; // 1월=0,12월=11이므로 1 더함
    let day  = date.getDate();
    if(fillZero){
        month = pad(month);
        day  = pad(day);
    }
    return year+splitter+month+splitter+day;
}

function getStringTime(date, fillZero, splitter){
    fillZero = fillZero || true;
    splitter = splitter || ':';

    let hours  = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if(fillZero){
        hours = pad(hours);
        minutes  = pad(minutes);
        seconds  = pad(seconds);
    }
    return hours+splitter+minutes+splitter+seconds;
}

function dateFromMysqlDateTime(date){ 
    let t, result = null;
    if( typeof date === 'string' ){
        if(date.length > 19)
            date = date.substring(0, 19);

        //console.log("datetime="+date);
        t = date.split(/[- :T]/);
        //when t[3], t[4] and t[5] are missing they defaults to zero
        result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
    }

    return result;
}

function getNowDate() {
    return get(httpHelper.getApiUrl()+`/common/getNowDate`, {headers: authHeader()})
    /* .then((response) => {
        console.log('getNowDate response data :: '+response.data);
        if(response.status === 200)
            return  new Date(response.data);
        else
            return new Date();
    }); */
}

function lastDays(d, lastDay) {
    var dayOfMonth = d.getDate();
    d.setDate(dayOfMonth - lastDay);
    return d;
}

function isNumber(s) {
    s += ''; // 문자열로 변환
    s = s.replace(/^\s*|\s*$/g, ''); // 좌우 공백 제거
    if (s === '' || isNaN(s)) return false;
    return true;
}

function dhm(t){
    var cd = 24 * 60 * 60 * 1000,
        ch = 60 * 60 * 1000,
        d = Math.floor(t / cd),
        h = Math.floor( (t - d * cd) / ch),
        m = Math.round( (t - d * cd - h * ch) / 60000);
        
  if( m === 60 ){
    h++;
    m = 0;
  }
  if( h === 24 ){
    d++;
    h = 0;
  }
  return [d, pad(h), pad(m)].join(':');
}
